import { useMutation } from "@apollo/client";
import { create, show, useModal } from "@ebay/nice-modal-react";

import FlashContext from "components/FlashMessages/FlashContext";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import useTypedContext from "hooks/useTypedContext";

import { AwsIntegrationView } from "../../useSearchCloudIntegrations/gql";
import AwsIntegrationDeleteConfirmationContent from "./Content";
import { DELETE_AWS_INTEGRATION } from "./gql";

type DeleteConfirmationProps = {
  integration: AwsIntegrationView;
  refetchQueriesOnDelete?: string[];
  onDeleteSuccess?: () => void;
};

const AwsIntegrationDeleteConfirmation = create(function DeleteConfirmation({
  integration,
  onDeleteSuccess,
  refetchQueriesOnDelete,
}: DeleteConfirmationProps) {
  const modal = useModal();

  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const [deleteIntegration, { loading }] = useMutation(DELETE_AWS_INTEGRATION, {
    awaitRefetchQueries: true,
    refetchQueries: refetchQueriesOnDelete,
  });

  const onConfirm = () => {
    deleteIntegration({ variables: { id: integration.id } })
      .then((data) => {
        if (data?.data?.awsIntegrationDelete?.id) {
          reportSuccess({ message: "Integration successfully removed" });
          modal.hide();
          onDeleteSuccess?.();
        }
      })
      .catch(onError);
  };

  return (
    <DeleteConfirmationModal
      title="Delete integration"
      onConfirm={onConfirm}
      isLoading={loading}
      isDismissable={!loading}
    >
      <AwsIntegrationDeleteConfirmationContent integration={integration} />
    </DeleteConfirmationModal>
  );
});

export const showAwsIntegrationDeleteConfirmation = (props: DeleteConfirmationProps) =>
  show(AwsIntegrationDeleteConfirmation, props);
